import { connect } from 'react-redux';
import {
	updateQuizzes,
	updateQuiz,
	deleteQuiz,
} from '../actions/question';
import {
	deleteRecipe,
	updateRecipe,
} from '../actions/recipe';
import { REQUESTING } from '../constants';
import QuizList from '../components/organisms/QuizList/index';
import {sortQuizzes} from '../logics/quiz';
import Errors from '../errors';

import {ROUTES} from '../constants';

const mapStateToProps = ({recipeReducer,createQuiz,location},ownProps) => {
	const {recipeId} = location.payload;
	const {recipes} = createQuiz;
	const {error,fetchingState} =recipeReducer;
	const recipe = recipes.find(r=>r.id===recipeId);
	if(!recipe){
		return {
			error : Errors.NotFoundRecipe
		};
	}
	if(REQUESTING.FAIL===fetchingState){
		return {
			error,
		};
	}
	const {content} = recipeReducer;
	const quizzes = (recipe.quizzes&&sortQuizzes(recipe.quizzes)) || [];
	return {
		...ownProps,
		recipe,
		quizzes,
		showModal:content.show,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onCheckQuiz: (recipeId,quizId, checked) =>{
			dispatch(updateQuiz(recipeId,quizId,{checked : checked}));
		},
		onPublish : (recipeId) => (published)=> {
			dispatch(updateRecipe({published}, recipeId));
		},
		onDeleteQuiz: (quizId) =>{
			dispatch(deleteQuiz(quizId));
		},
		onRequestEditQuiz: (recipeId=null, quizId=null)=>{
			if(quizId===null){
				dispatch({
					type : ROUTES.REQUEST_QUIZ_EDITOR,
					payload : {
						recipeId,
						quizId:'create',
						create:true
					}
				});
			}
			else{
				dispatch({
					type : ROUTES.REQUEST_QUIZ_EDITOR,
					payload : {
						recipeId,
						quizId
					}
				});
			}
		},
		onDeleteRecipe: (recipe) =>{
			dispatch(deleteRecipe(recipe));
		},
		onCloseRecipe: ()=>{
			dispatch({
				type : ROUTES.CREATE_QUIZ_SELECTED
			});
		},
		onJumpToSummaryPage : (recipe)=>()=>{
			recipe && dispatch({
				type : ROUTES.RECIPE_DETAIL,
				payload : {
					recipeId : recipe.id
				}
			});
		},
		onRemoveTag : (tag,recipe) =>{
			const tags = recipe.tags ? recipe.tags.filter(t=>t!==tag) : [];
			dispatch(updateRecipe({'tags':tags}, recipe.id));
		},
		onAddTag : (tag, recipe) =>{
			let tags = recipe.tags ? recipe.tags : [];
			tags.push(tag);
			dispatch(updateRecipe({'tags':tags}, recipe.id));
		},
		handleShuffle : (recipe)=>(enable) =>{
			dispatch(updateRecipe({'shuffle':enable}, recipe.id));
		},
		onChangeRecipeName : (newName, recipe) => {
			dispatch(updateRecipe({'name':newName}, recipe.id));
		},
		onSetTimer : (time, recipe) => {
			dispatch(updateRecipe({'timeLimit':time}, recipe.id));
		},
		onChangeRecipeDiscription : (discription, recipe) => {
			dispatch(updateRecipe({'discription':discription}, recipe.id));
		},
		onSort : (quizzes,recipe,newIndices) =>{
			if(newIndices.every((val,idx)=>val===idx)) {
				return;
			}
			const newQuizzes = newIndices.map( (oldIdx,newIdx) => {
				return {...quizzes[oldIdx],number:newIdx};
			});
			dispatch(updateQuizzes(recipe,newQuizzes,quiz=>{
				return ({number:quiz.number});
			}));
		},
		onPlayQuiz : (recipe) => {
			dispatch({
				type : ROUTES.REQUEST_PLAY_QUIZ,
				payload : {
					recipeId : recipe.id,
					userId : recipe.uid
				}
			});
		}
	};
};


export default connect(mapStateToProps, mapDispatchToProps)(QuizList);